import { createGlobalStyle } from "styled-components";
import { pxToRem } from "./utils";

export const GlobalStyles = createGlobalStyle`
  /* Добавляем CSS-переменные для работы с viewport и клавиатурой */
  :root {
    --real-vh: 100vh;
    --keyboard-height: 0px;
    --keyboard-visible: 0;
  }

  *, *::before, *::after {
    box-sizing: border-box;
  }

  html {
    font-size: 50%;
    height: 100%;

    @media (min-width: 800px) {
      font-size: 30.75%;
    }
    @media (min-width: 900px) {
      font-size: 35.75%;
    }

    @media (min-width: 900px) {
      font-size: 35.75%;
    }
    @media (min-width: 1200px) {
      font-size: 40.75%;
    }

    @media (min-width: 1582px) {
      font-size: 47.75%;
    }

    @media (min-width: 1855px) {
      font-size: 56.00%;
    }
  }

  html, body {
    font-family: ${({ theme }) => theme.fonts.primary};
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    scrollbar-width: none;
    height: 100%;
    overflow-x: hidden;
  }

  #root {
    scrollbar-width: none;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  /* Переопределения для PrimeReact Toast */
  .p-toast {
    min-width: ${pxToRem(350)} !important;  /* регулировка ширины окна тоста */
    font-size: ${pxToRem(16)} !important; /* общий размер шрифта в тосте */
  }
  
  .p-toast-message {
    font-size: ${pxToRem(16)} !important; /* размер шрифта самого сообщения */
  }
  
  .p-toast-detail {
    white-space: pre-line;
  }

  .p-datepicker.p-component.custom-calendar-panel.p-datepicker-monthpicker.p-ripple-disabled {
    font-size: ${pxToRem(10)};
    margin-left: ${pxToRem(50)};
    width: ${pxToRem(250)} !important;
  }

  .p-datepicker.p-component.custom-calendar-panel.p-datepicker-monthpicker.p-ripple-disabled.p-connected-overlay-enter {
    font-size: ${pxToRem(10)};
    margin-left: ${pxToRem(50)};
    width: ${pxToRem(250)} !important;
  }

  .p-datepicker.p-component.custom-calendar-panel.p-datepicker-monthpicker.p-ripple-disabled.p-connected-overlay-enter-done {
    font-size: ${pxToRem(10)};
    margin-left: ${pxToRem(50)};
    width: ${pxToRem(250)} !important;
  }

  /* Делаем основной контейнер квадратным */
  .p-datepicker {
    width: ${pxToRem(250)}; 
    height: ${pxToRem(280)}; 
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    margin-left: ${pxToRem(50)};
  }

  .p-datepicker.p-datepicker-monthpicker {
    width: ${pxToRem(250)};
    height: ${pxToRem(170)};
  }

  /* Уменьшаем размеры внутренней таблицы */
  .p-datepicker-calendar {
    width: 100%;
    table-layout: fixed; 
  }

  /* Уменьшаем размеры ячеек */
  .p-datepicker-calendar td,
  .p-datepicker-calendar th {
    height: ${pxToRem(5)}; 
    width: ${pxToRem(5)}; 
    padding: 0;
    text-align: center;
    vertical-align: middle;
  }

  /* Уменьшаем расстояние между строками */
  .p-datepicker-calendar tr {
    line-height: 1;
    margin: 0; 
  }

  /* Уменьшаем отступы внутри ячеек */
  .p-datepicker-calendar td span {
    padding: 0;
    font-size: ${pxToRem(10)}; 
    line-height: 1.2;
  }

  /* Заголовок календаря */
  .p-datepicker-header {
    padding: ${pxToRem(4)} 0;
    text-align: center;
    font-size: ${pxToRem(14)};
  }

  /* Кнопки переключения */
  .p-datepicker-header button {
    width: ${pxToRem(24)};
    height: ${pxToRem(24)};
    padding: 0;
  }

  /* Стрелки переключения */
  .p-datepicker-prev-icon,
  .p-datepicker-next-icon {
    width: ${pxToRem(14)};
    height: ${pxToRem(14)};
  }

  /* Дни недели (thead) */
  .p-datepicker-calendar thead th span {
    font-size: ${pxToRem(10)};
    line-height: 1;
    text-align: center;
  }

  .p-datepicker-title {
    margin-left: ${pxToRem(30)};
    margin-right: ${pxToRem(30)};
    gap: ${pxToRem(40)};
    display: flex;
    justify-content: space-between;
  }
`;

export default GlobalStyles;
